module.exports = __webpack_public_path__ + "img/category-12.d4eb44cd.svg";